import { Icon, IconsEnum } from 'components/Icons';
import React, { memo, useMemo } from 'react';
import {
  addAvvenimentoToFavouriteList,
  removeAvvenimentoFromFavouriteList,
} from '../../../liveInternalLayout/liveFavouriteAvvenimentoSlice';
import { useAvvenimento, useInfoTipo, useScommessa } from 'features/sport/hooks';

import { KeyManagerSport } from 'features/sport';
import { ScommesseAvvenimentoScore } from 'components/scommesseAvvenimentoScore';
import { ScommesseTableCompetitors } from 'components/scommesseTable/scommesseTableCompetitors';
import { ScommesseTableDescription } from 'components/scommesseTable/scommesseTableCompetitors/ScommesseTableCompetitors';
import { ScommesseTableTitle } from 'components/scommesseTable/scommesseTableTitle';
import { SportScommesseRenderConditional } from 'features/sport/components/sportScommesseRenderConditional';
import { SportsCompetitor } from 'types/swagger';
import classNames from 'classnames';
import raise from 'utility/raise';
import styles from './LiveNavAccordionScommessa.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useIsFavourite } from '../../hooks';
import { useTranslation } from 'hooks/useLingUI';

export type LiveNavAccordionScommessaProps = {
  index?: number;
  identifier: string;
};

const LiveNavAccordionScommessa = ({ identifier }: LiveNavAccordionScommessaProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { avvenimentoKey, tipoScommessaId, scommessaKey } = new KeyManagerSport(identifier!);

  const { isFavourite, isAuthenticated } = useIsFavourite(avvenimentoKey);
  // const infoTipoScommessa = useInfoTipo(tipoScommessaId);
  // const selectedEsito = useEsitoByScommessa(scommessaKey);
  const avvenimento = useAvvenimento(avvenimentoKey);
  const scommessa = useScommessa(scommessaKey);
  const infoTipo = useInfoTipo(tipoScommessaId);

  const {
    key,
    score,
    server,
    isMatch,
    status,
    redCards,
    matchTime,
    statusTrKey,
    competitors,
    descrizione,
    descrizioneTrKey,
  } = useMemo(() => {
    let isMatch = false;
    const { key, live, descrizione, descrizioneTrKey, firstCompetitor, secondCompetitor } = avvenimento ?? {};
    const { score, server, status, statusTrKey, redCards, matchTime } = live ?? {};
    const competitors: Array<SportsCompetitor | undefined> = [];
    if (firstCompetitor || secondCompetitor) {
      isMatch = true;
      competitors.push(firstCompetitor);
      competitors.push(secondCompetitor);
    }

    return {
      key,
      score,
      server,
      status,
      isMatch,
      redCards,
      matchTime,
      statusTrKey,
      competitors,
      descrizione,
      descrizioneTrKey,
    };
  }, [avvenimento]);

  if (!avvenimento) {
    return raise('Unable to find avvenimento');
  }

  const onPinButtonClickHanlder = (): void => {
    if (isFavourite) {
      dispatch(
        removeAvvenimentoFromFavouriteList({
          keyAvvenimento: avvenimentoKey,
        })
      );
    } else {
      dispatch(
        addAvvenimentoToFavouriteList({
          keyAvvenimento: avvenimentoKey,
          slugAvvenimento: avvenimento?.slugDefaultScommessaGroup!,
          infoTipoScommessaKey: [+tipoScommessaId],
        })
      );
    }
  };

  /*
  const renderEsiti = (): JSX.Element => {
    if (scommessa?.isClosed) {
      const boxes = infoTipoScommessa ? calculateBoxNumber(infoTipoScommessa, esitoTrKey) : [];
      return (
        <div className={styles.wrapperEvento}>
          {boxes.map(({ size, header, headerTrKey }, index) => (
            <div className={styles.eventoContainer} key={`${header}_${index}`}>
              <ScommesseEsitoSkeleton size={size} header={header} headerTrKey={headerTrKey} testId={headerTrKey} />
            </div>
          ))}
        </div>
      );
    }

    return <SportScommesseRenderConditional hasHeader={true} forceShow={true} scommessaKey={scommessaKey} showOnlyBilanciata={true} containerClassName={styles.wrapperEvento} />
  };
  */

  return (
    <div className={styles.container} data-testid={identifier}>
      <div className={styles.wrapperAvvenimento}>
        <div className={styles.wrapperDateTime}>
          <ul className={styles.list}>
            {status && (
              <li className={styles.listItem} suppressHydrationWarning>
                {t(statusTrKey, status)}
              </li>
            )}
            {matchTime && <li className={classNames(styles.listItem, styles.matchTime)}>{matchTime}&apos;</li>}
          </ul>
        </div>
        {isAuthenticated && scommessa && (
          <button type="button" className={styles.buttonPin} onClick={onPinButtonClickHanlder}>
            <Icon
              color={isFavourite ? 'var(--color-primary)' : 'var(--color-on-bg-primary)'}
              iconId={isFavourite ? IconsEnum.FULL_PINNED : IconsEnum.PIN}
              className={styles.iconPin}
            />
          </button>
        )}
        <div className={styles.wrapperCompetitors}>
          {isMatch ? (
            <React.Fragment>
              <ScommesseAvvenimentoScore score={score} server={server} className={styles.score} />
              <ScommesseTableCompetitors
                redCards={redCards}
                className={styles.competitors}
                competitors={competitors}
                avvenimentoKey={key!}
              />
            </React.Fragment>
          ) : (
            <ScommesseTableDescription
              className={styles.description}
              descrizione={descrizione}
              avvenimentoKey={key!}
              descrizioneTrKey={descrizioneTrKey}
            />
          )}
        </div>
      </div>
      {isMatch && scommessa && (
        <div className={styles.wrapperTipoScommessa}>
          <ScommesseTableTitle
            labelDx={infoTipo?.descrizione}
            labelDxTrKey={infoTipo?.descrizioneTrKey}
            className={styles.title}
          />
          {/* renderEsiti() */}
          <SportScommesseRenderConditional
            hasHeader={true}
            forceShow={true}
            bypassFilter={true}
            showOnlyBilanciata={true}
            scommessaKey={scommessaKey}
            containerClassName={styles.wrapperEvento}
          />
        </div>
      )}
    </div>
  );
};

export default memo(LiveNavAccordionScommessa);
